<div class="full-screen">
  <div class="centered">
    <form [formGroup]="loginForm" novalidate (ngSubmit)="onSubmit()">
      <mat-card class="form-padding"   style="border-radius: 40px;"  >
        <div class="loginImageContainer">
          <img class="loginImage" [src]="img"/>
        </div>
        <mat-card-title class="" style="color:#888; font-size: 22px; font-weight: 300;">
          Admin Log In
        </mat-card-title>
        <mat-card-content *ngIf="loading">
          <!-- <app-sp-spinner></app-sp-spinner> -->

          <mat-spinner  diameter="70" style="margin: 50px auto 50px auto;"></mat-spinner>
        
        </mat-card-content>
        <mat-card-content *ngIf="!loading && !isCustomer">
          <div class="row">
            <div class="col" style="text-align: center;">
              It looks like you are trying to log into a partner account.<br> To sign into this account, please go to:<br> <a style="line-height: 50px; font-size: 15px; font-weight: 500;" href="https://dashboard.stayprivate.com">https://dashboard.stayprivate.com</a>
            </div>
          </div>          
          <div class="row">
            <button mat-flat-button color="primary"  style="width: 200px;max-width: 90%;margin:auto;height: 40px; background-color: #aaa;">BACK</button>
          </div>          
        </mat-card-content>
        <mat-card-content *ngIf="!loading && isCustomer">
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline" class="login-input">
                <input matInput placeholder="Username or email" formControlName="UserName">
                <mat-error *ngIf="loginForm.controls['UserName'].hasError('required')">
                  Email is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline" class="login-input">
                <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="UserPwd" placeholder="Password">
                <button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                  <mat-icon style="font-size: 20px; position: relative; left:10px">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
                <mat-error *ngIf="loginForm.controls['UserPwd'].hasError('required')">
                  Password is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <button mat-flat-button color="primary" class="sp-background" style="width: 360px;max-width: 90%;margin:auto;height: 47.5px;border-radius: 24px;">SIGN IN</button>
          </div>
          <div class="row">
            <a mat-flat-button routerLink="/forgot-password" class="sp-title">
              Forgotten password
            </a>
          </div>
          <div>
            <p style="padding: 20px 10px 0px;margin-bottom: 0px;max-width: 400px;margin:auto; text-align: center;" >By logging into this dashboard you accept that you will use it in accordance with the StayPrivate <a target="_blank" href="https://stayprivate.com/terms">terms</a>.</p>
          </div>
        </mat-card-content>
      </mat-card>
      
      
    </form>

  </div>
  
</div>
<!-- SP_Logo_Icon+Text_Blue.svg -->

